import { ComponentType } from "@/components/features/DisplayScreen/displayScreenTypes";

export type LayoutVersion = "1.0";
export type LayoutType = "columns" | "grid";
export type ComponentAlign = "left" | "center" | "right";
export type TimeFormat = "12h" | "24h";
export type WeekdayFormat = "long" | "short" | "narrow";
export type ZoneType = "content_blocks" | "schedule";

export interface TimeConfig {
  showTime: boolean;
  timeFormat: TimeFormat;
  showDate: boolean;
  dateFormat: string;
  showWeekday: boolean;
  weekdayFormat: WeekdayFormat;
  separator: string;
  locale: string;
}

export interface BaseComponent {
  type: ComponentType;
  visible: boolean;
  align?: ComponentAlign;
}

export interface LogoComponent extends BaseComponent {
  type: "logo";
}

export interface NameComponent extends BaseComponent {
  type: "room_name" | "venue_name" | "display_name";
  fallback?: ComponentType;
}

export interface TimeComponent extends BaseComponent {
  type: "time";
  config: TimeConfig;
}

export interface RunningMessagesComponent extends BaseComponent {
  type: "running_messages";
}

export type Component =
  | LogoComponent
  | NameComponent
  | TimeComponent
  | RunningMessagesComponent;

export interface Section {
  height: string;
  autoHide: boolean;
  components: Component[];
}

export interface Zone {
  id: string;
  type: ZoneType;
  widthPercent: number;
}

export interface MainSection {
  gap: string;
  zones: Zone[];
}

export interface LayoutConfig {
  version: LayoutVersion;
  layoutType: LayoutType;
  header: Section;
  main: MainSection;
  footer: Section;
}

export const defaultLayoutConfig = {
  version: "1.0",
  layoutType: "columns",
  header: {
    visible: true,
    autoHide: true,
    height: "3.75rem",
    components: [
      { type: "logo", visible: true, align: "left" },
      {
        type: "venue_name",
        visible: true,
        align: "center",
        fallback: "display_name",
      },
      {
        type: "time",
        visible: true,
        align: "right",
        format: "MMMM D, YYYY h:mm A",
      },
    ],
  },
  main: {
    gap: "0rem",
    zones: [
      { id: "left-zone", widthPercent: 33 },
      { id: "right-zone", widthPercent: 67 },
    ],
  },
  footer: {
    visible: true,
    autoHide: true,
    height: "3.75rem",
    components: [{ type: "running_messages", visible: true }],
  },
};
